import React, { useEffect, useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { BiCamera, BiLoader } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { makeRequest } from "../../utils/makeRequest";
import * as urls from '../../utils/urlConst'
import toastNotify from "../../utils/toastNotify";
import Textfield from "../../components/textField/TextField";
import Loader from "../../components/Loader";
import { converToBase64, getUserData, setLocalUserData } from "../../utils/common";
import { handleUserProfile } from "../../redux/profile";
import { useDispatch } from "react-redux";
import { exceptionLog } from "../../utils/common";

type profileProps = {
  EmailId: string,
  FirstName: string,
  LastName: string,
  MobileNo: string,
  NickName: string,
  Photo: string,
}

const ManageProfile = () => {
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [updateLoader, setUpdateLoader] = useState<boolean>(false);
  const [profileData, setProfileData] = useState<profileProps | any>({});
  const [userImage, setUserImage] = useState<string | null>(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState<any>(profileData);
  const userData = getUserData();

  const handleSingleFile = async (e: React.ChangeEvent<any>) => {
    const imageFile = e.target.files[0];
    const fileSize = (imageFile?.size / 1048576).toFixed(2);
    const maxImageSize = process.env.REACT_APP_PROFILE_IMAGE_SIZE
    if (imageFile) {
      if (Number(fileSize) > Number(maxImageSize)) {
        return toastNotify(`Images size less then ${maxImageSize} MB`, 'error');
      }
      const profiletImg: any = await converToBase64(imageFile);
      // const withoutExtention = profiletImg.split(",")[1];
      setUserImage(profiletImg);
    }
  };

  const fatchProfile = async () => {
    try {
      setIsLoader(true);
      const payload = {};
      const config = {};
      await makeRequest('POST', urls.getProfile, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE[0];
          setProfileData(response);
          setFormData(response);
          setUserImage(response.Photo)
          dispatch(handleUserProfile(response.Photo));
        } else {
          toastNotify(result.MESSAGE, 'error');
        };
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Add feedback", "N");
      }
    } finally {
      setIsLoader(false);
    }
  };

  useEffect(() => {
    fatchProfile();
  }, []);

  const updateUserProfile = async (val: any) => {
    try {
      if (JSON.stringify(profileData) === JSON.stringify(formData) && JSON.stringify(userImage) === JSON.stringify(formData.Photo)) {
        return toastNotify("You have not made any changes.", 'error');
      };

      setUpdateLoader(true);
      const payload = {
        FirstName: val.firstName,
        LastName: val.lastName,
        MobileNo: val.mobileNo,
        EmailId: val.emailId,
        Photo: userImage,
      };

      const config = {};

      await makeRequest('POST', urls.updateProfile, payload, config).then((result) => {
        if (result.STATUS === '0') {
          toastNotify(result.MESSAGE, 'success');
          navigate('/dashboard')
          fatchProfile();
          setLocalUserData({ ...userData, FirstName: val.firstName });
        } else {
          toastNotify(result.MESSAGE, 'error');
        };
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Add feedback", "N");
      }
    } finally {
      setUpdateLoader(false);
    }
  }

  const initialValues = {
    firstName: profileData.FirstName,
    lastName: profileData.LastName,
    mobileNo: profileData.MobileNo,
    emailId: profileData.EmailId,
  };

  const validation = Yup.object({
    firstName: Yup.string().required('First Name is a required field'),
    mobileNo: Yup.string().required('Mobile No. is a required field'),
    emailId: Yup.string().email('Email id must be a valid email').matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Must have valid email id'),
  });

  return (
    <div>
      <div className=" mb-3">
        <h2 className="text-base mb-0 fw-semibold">Manage Profile</h2>
      </div>
      <Card>
        <Card.Body>
          {!isLoader ?
            <Formik
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={(values) => {
                updateUserProfile(values)
              }}
            >
              {({ values, handleBlur, handleChange, handleSubmit, setFieldValue }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={4} className='d-flex align-items-center flex-column'>
                        <div className="avatar-upload">
                          {userImage !== null && userImage !== "" ?
                            <div className="avatar-preview">
                              <img src={userImage ? userImage : ``} alt="userName" className='imagePreview' />
                            </div>
                            : ''
                          }
                          <div className={` ${userImage !== null && userImage !== "" ? 'add-section' : 'avatar-edit'}`} >
                            <input type='file' id="userProfile" name='userProfile' accept=".png, .jpg, .jpeg" onChange={handleSingleFile} />
                            <label htmlFor="userProfile">
                              <BiCamera style={{ fontSize: 20, color: '#fff' }} />
                            </label>
                          </div>
                        </div>
                        {userImage !== null && userImage !== "" ?
                          <Button type="button" className="btn-sm mt-3" variant="outline-danger" onClick={() => { setUserImage(""); setFormData({ ...formData, Photo: "" }); }}>Reset Profile</Button>
                          : ""
                        }
                      </Col>

                      <Col md={8} className="mt-4 mt-md-0">
                        <Row>
                          <Col md={6} className='mt-3'>
                            <Textfield
                              label="First Name"
                              name="firstName"
                              id="firstName"
                              size="small"
                              required
                              disabled={updateLoader}
                              maxLength={30}
                              value={values.firstName}
                              onChange={(e) => { handleChange(e); setFormData({ ...formData, FirstName: e.target.value }) }}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage name="firstName" className='error-msg' component="div" />

                          </Col>
                          <Col md={6} className='mt-3'>
                            <Textfield
                              label="Last Name"
                              name="lastName"
                              id="lastName"
                              size="small"
                              disabled={updateLoader}
                              maxLength={30}
                              value={values.lastName}
                              onChange={(e) => { handleChange(e); setFormData({ ...formData, LastName: e.target.value }) }}
                              onBlur={handleBlur}
                            />
                          </Col>
                          <Col md={6} className='mt-3'>
                            <Textfield
                              label="Mobile No."
                              name="mobileNo"
                              id="mobileNo"
                              size="small"
                              required
                              disabled={updateLoader}
                              maxLength={10}
                              value={values.mobileNo}
                              onChange={(e) => {
                                e.preventDefault();
                                const { value } = e.target;
                                const regex = /^[0-9]*[.,]?[0-9]*$/;
                                if (regex.test(value.toString())) {
                                  setFieldValue("mobileNo", value);
                                  setFormData({ ...formData, MobileNo: value })
                                }
                              }}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage name="mobileNo" className='error-msg' component="div" />
                          </Col>
                          <Col md={6} className='mt-3'>
                            <Textfield
                              label="Email Id"
                              type="email"
                              name="emailId"
                              id="emailId"
                              size="small"
                              disabled={updateLoader}
                              maxLength={100}
                              value={values.emailId}
                              onChange={(e) => { handleChange(e); setFormData({ ...formData, EmailId: e.target.value }) }}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage name="emailId" className='error-msg' component="div" />
                          </Col>

                          <Col md={12} className='mt-3'>
                            <div className="d-flex justify-content-end gap-2">
                              <Button
                                type="button"
                                variant='outline-orange'
                                className="btn-sm"
                                onClick={() => navigate(-1)}
                              >
                                Cancel
                              </Button>
                              <Button type="submit" variant="orange" className="btn-sm" disabled={updateLoader}>
                                {!updateLoader ? 'Update' : <><BiLoader className='icon-loader text-white text-lg' /> Loading...</>}
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </form>
                )
              }}
            </Formik>
            : <div style={{ height: '75vh' }} className='d-flex justify-content-center align-items-center'>
              <Loader />
            </div>
          }
        </Card.Body>
      </Card>
    </div>
  );
};

export default ManageProfile;
